import { useEffect, useState } from 'react';
import { useI18n } from '../i18n/index.jsx';

export const GlobalCookieConsent = () => {
  const { t } = useI18n();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà donné son consentement
    const savedConsent = localStorage.getItem('cookieConsent');
    if (!savedConsent) {
      // Afficher la banneau après 1 seconde pour éviter les conflits d'affichage
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    } else {
      // Activer GA4 si consentement déjà donné
      const consent = JSON.parse(savedConsent);
      if (consent.analytics) {
        window['ga-disable-G-RKHHB1N1X7'] = false;
      }
    }
  }, []);

  const handleAcceptAll = () => {
    const consent = {
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    window['ga-disable-G-RKHHB1N1X7'] = false;
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    const consent = {
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    window['ga-disable-G-RKHHB1N1X7'] = true;
    setShowBanner(false);
  };

  const handleManagePreferences = () => {
    const consent = {
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    window['ga-disable-G-RKHHB1N1X7'] = true;
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  const policyLink = t('cookies.policyLink');

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900 border-t border-slate-700 p-4 md:p-6 shadow-2xl">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          {/* Texte du consentement */}
          <div className="flex-1">
            <h3 className="text-white font-semibold text-lg mb-2">
              {t('cookies.title')}
            </h3>
            <p className="text-slate-300 text-sm leading-relaxed">
              {t('cookies.message')}
              {' '}
              <a href={policyLink} className="text-emerald-400 hover:text-emerald-300 underline">
                {t('cookies.policyLabel')}
              </a>
              {' '}
              {t('cookies.moreInfo')}
            </p>
          </div>

          {/* Boutons */}
          <div className="flex gap-3 w-full md:w-auto flex-shrink-0">
            <button
              onClick={handleRejectAll}
              className="flex-1 md:flex-none px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition-colors text-sm font-medium border border-slate-600"
            >
              {t('cookies.reject')}
            </button>
            <button
              onClick={handleManagePreferences}
              className="flex-1 md:flex-none px-4 py-2 bg-slate-700 text-white rounded-lg hover:bg-slate-600 transition-colors text-sm font-medium"
            >
              {t('cookies.settings')}
            </button>
            <button
              onClick={handleAcceptAll}
              className="flex-1 md:flex-none px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-500 transition-colors text-sm font-medium shadow-lg shadow-emerald-500/30"
            >
              {t('cookies.acceptAll')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
